// extracted by mini-css-extract-plugin
export var activityContainer = "_ib-0";
export var typingIndicatorContainer = "_ib-1";
export var typingIndicatorDot = "_ib-2";
export var wave = "_ib-3";